import { Link } from "@tanstack/react-router";

export function PlaceholderPage({ title, body }: { title: string; body: string }) {
  return (
    <div className="mx-auto max-w-2xl p-8">
      <h1 className="text-xl">{title}</h1>
      <p className="mt-3 text-sm leading-6" style={{ color: "var(--muted)" }}>
        {body}
      </p>
      <Link to="/" className="mt-6 inline-block text-sm" style={{ color: "var(--gold)" }}>
        Back to map
      </Link>
    </div>
  );
}
